import crypto from 'crypto'
import Xxtea from 'xxtea-node'
import Md5 from 'md5'
import { profile } from '../stores/storages/ProfileStorage'

const publicKey = '-----BEGIN PUBLIC KEY-----\n'
  + 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArlH8kiBxW7FqFXvT+ioU\n'
  + 'BT//eiKxFEifDAoylSOOgI+fqqHAwLIfcq5Z2obcy8EMpw5X5L0vNm6Mpa9n4GRq\n'
  + 'Pcp60s9YqRn2Qe3+DXBKDqU1Uuq8d7fhYBG+eK+YWwa+9N/SjX/h9tYZsINVrcJ3\n'
  + 'yy8brs7FmT3YdIGW52sHa3IQlBpdXpa245FX9jrnXTj9bGvmW+faykO2tQhkaIC5\n'
  + 'KaEpR65xwZp0JrpqS2NwSktNWapveynR+g+OpyUncmvC7qH/Q9wC8W2I9XnRkEkD\n'
  + 'nefat8intObmVkgAMkn67Y0/uxziGA5lpur/GOape4Xk7Kd/3vBRqr+7GL5Urvrk\n'
  + 'qQIDAQAB\n'
  + '-----END PUBLIC KEY-----\n'

const publicKeyMobile = '-----BEGIN PUBLIC KEY-----\n'
  + 'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgF3g82nB1ImzAwSN7JXeOC7wChDA4Nbzun' +
  '/2B60sB04LCxBt88yRQTK734ugqAJ9cnYYNjwYfzcoTmubiMygsdtoNf1HTmezAL+ppsJxZ' +
  '/TlfomXz6zUS2HxNUdNcgX0NdHpq5OR9713p6tiq5Z4TdYjja9P7FEG8p4xf8snDEjhAgMBAAE=\n'
  + '-----END PUBLIC KEY-----\n'

class Formatter {
  encrypt = (str, isMobileKey) => {
    const token = profile.token
    const md5 = this._encryptMD5(str)
    const rsa = this._encryptRSA({ md5, token }, isMobileKey)
    return rsa
  }
  xxteaEncrypt = (str, customKey) => {
    const key = customKey || profile.authAPI
    return Xxtea.encryptToString(str, key)
  }
  xxteaDecrypt = (str, customKey) => {
    const key = customKey || profile.authAPI
    return Xxtea.decryptToString(str, key)
  }

  _encryptMD5 = str => Md5(str)

  _encryptRSA = (data, isMobileKey) => {
    const pkey = isMobileKey ? publicKeyMobile: publicKey;
    const msg = JSON.stringify(data);
    const encryptedData = crypto.publicEncrypt({
      key: pkey,
      padding: crypto.constants.RSA_PKCS1_PADDING,
    }, Buffer.from(msg, 'utf-8'));
    return encryptedData.toString('base64');
  }
}

export default new Formatter()
